import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Table from 'views/management/managementContact/detailsTable'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * DetailsView class extending JetView to create a detailed view for management contacts.
 */
export default class DetailsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration with pagination and export options
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable1').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable1').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export2',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable1'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Requisitos'),
                                    ignore: {
                                        detailTittle: true, // Ignore detail title in export
                                        ActionTittle: true, // Ignore action title in export
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable1'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Requisitos'),
                                        autowidth: true, // Automatically adjust width for PDF
                                        ignore: {
                                            detailTittle: true, // Ignore detail title in export
                                            ActionTittle: true, // Ignore action title in export
                                        },
                                    });
                                }
                            }
                            $$('Export2').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        // Left panel configuration with toolbar, table, and toolbar
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        {
                            view: 'label', // Label for the history section
                            label: _('Historial de gestiones'),
                            width: 200,
                        },
                        {
                            view: 'button', // Button to create a note
                            label: _('Crear Nota'),
                            width: 100,
                            click: () => {
                                // Click event to open modal
                                this.app.callEvent('managementContact:openModal', []);
                            },
                        },
                    ],
                },
                Table, // Including the Table component
                toolbar, // Including the toolbar
            ],
        };

        // Returning the main configuration object for the view
        return {
            width: screen !== 'small' ? 500 : 230, // Width based on screen size
            height: screen.width < 500 ? 500 : 0, // Height based on screen width
            type: 'wide', // Type of layout
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
